import Vue from 'vue';
import Router from 'vue-router';
import api from '@/api';
import Glossary from './views/Glossary.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Reset from './views/Reset.vue';
import Resources from './views/Resources.vue';
import Page from './views/Page.vue';

Vue.use(Router);

const refresh = () => {
    window.location.href = '/';
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', name: 'home', component: Home },
        { path: '/glossary', name: 'glossary', component: Glossary },
        { path: '/login', name: 'login', component: Login },
        {
            path: '/logout',
            beforeEnter: (to, from, next) => {
                api.get('/logout')
                    .then(refresh)
                    .catch(refresh);
            }
        },
        {
            path: '/logout/all',
            beforeEnter: (to, from, next) => {
                api.get('/logout?all')
                    .then(refresh)
                    .catch(refresh);
            }
        },
        { path: '/reset', name: 'reset', component: Reset },
        { path: '/resources', name: 'resources', component: Resources },
        { path: '/page/:section/:page', name: 'page', component: Page, props: true },
        { path: '/admin', name: 'admin', component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue') },
        { path: '*', redirect: '/' }
    ]
});
